import { createAction, props } from '@ngrx/store';
import { CodeStringValues, ItemInputOptionDisplayRule } from 'src/app/models/pricing-view-models';

export const updateAllItemCodeStringValues = createAction(
  '[ItemCodeString] Update All Item Code Strings',
  props<{ CodeStringValues: CodeStringValues }>()
)


